module.exports = __webpack_public_path__ + "static/img/5.9c9d16e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/1/sp/5.png
// module id = qlgA
// module chunks = 0